// extracted by mini-css-extract-plugin
export default {"btn":"linkButton_btn__oSBuM"};